exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-edit-service-component .modal-card .modal-card-head {\n  background-color: #fff;\n  border: none;\n}\n.modal-edit-service-component .modal-card .card-content .list-custom-fields {\n  margin-top: 1.4rem;\n}\n.modal-edit-service-component .modal-card .card-content .list-custom-fields .list-custom-field-item .field {\n  margin-bottom: 1rem;\n}\n.modal-edit-service-component .change {\n  border: 1px solid #ffdd57;\n  border-radius: 6px;\n}\n.modal-edit-service-component .field {\n  max-width: 100%;\n}", ""]);

// exports
